/* Product page shortcuts.
   - Section buttons ("Try It Now" and similar) scroll back up to the bundle
     picker and Add to Cart instead of reloading the page they are on.
   - A "Try It Now" bar pins to the bottom while the reviews are on screen.
   - The "100,000+ Happy Customers" rating jumps down to the reviews. */
(function () {
  if (!document.body.classList.contains('sw-tpl-product')) return;

  /* Arriving from the header's "Reviews" link (#sw-reviews). The reviews sit
     at the very bottom and apps above them (bundles, reviews) load late and
     push the page down, so jump again once everything has loaded. On a
     template without the Swarva reviews section, fall back to the review
     app's own wrapper. */
  if (location.hash === '#sw-reviews') {
    var toReviews = function () {
      var t = document.getElementById('sw-reviews') || document.getElementById('trustoo-widget-wrapper');
      if (t) t.scrollIntoView({ block: 'start' });
    };
    toReviews();
    window.addEventListener('load', function () { setTimeout(toReviews, 400); });
  }
  var smooth = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

  document.addEventListener('click', function (e) {
    var cta = e.target.closest('.sw-section__cta a.sw-btn, .sw-guarantee a.sw-btn, [data-sw-sticky-cta] a');
    if (cta) {
      e.preventDefault();
      /* Land on the bundles (Kaching) with Add to Cart below; fall back to the top */
      var buy = document.querySelector('.sw-buy__app') || document.querySelector('.sw-buy__info');
      var top = 0;
      if (buy) {
        var header = document.querySelector('.section-header, sticky-header, .shopify-section-group-header-group');
        var offset = header ? header.getBoundingClientRect().height : 0;
        top = Math.max(buy.getBoundingClientRect().top + window.scrollY - offset - 12, 0);
      }
      window.scrollTo({ top: top, behavior: smooth });
      return;
    }

    var rating = e.target.closest('[data-sw-to-reviews]');
    if (rating) {
      var target = document.getElementById('sw-reviews') || document.getElementById('trustoo-widget-wrapper');
      if (!target) return;
      e.preventDefault();
      var header = document.querySelector('.section-header, sticky-header, .shopify-section-group-header-group');
      var offset = header ? header.getBoundingClientRect().height : 0;
      var top = target.getBoundingClientRect().top + window.scrollY - offset - 8;
      window.scrollTo({ top: Math.max(top, 0), behavior: smooth });
    }
  });

  /* Sticky "Try It Now": appears once the written reviews (below the star
     summary and photo grid) reach the top third of the screen, and goes
     away again once the reviews section has scrolled past. */
  var bar = document.querySelector('[data-sw-sticky-cta]');
  var reviews = document.getElementById('sw-reviews');
  if (bar && reviews) {
    var link = bar.querySelector('a');
    var shown = false, ticking = false;
    var update = function () {
      ticking = false;
      var list = document.getElementById('reviews-body') || reviews;
      var vh = window.innerHeight;
      var on = list.getBoundingClientRect().top < vh * 0.33 && reviews.getBoundingClientRect().bottom > vh * 0.6;
      if (on === shown) return;
      shown = on;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (link) link.tabIndex = on ? 0 : -1;
    };
    var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }
})();
